/** Vector footer artwork; motion follows the shell reveal and reduced-motion settings. */
export default function FooterArt() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='footer__art pf-art'
      width='2048'
      height='769'
      viewBox='0 0 2048 769'
      fill='none'
      data-observe=''
      aria-hidden='true'
      focusable='false'
    >
      <style>{`
.pf-art { --pf-blue:var(--accent-blue-text,#0067a3); --pf-light:var(--blue,#008dcc); --pf-pink:var(--cta-fill,#d9097a); --pf-gold:var(--accent-amber-text,#875d00); --pf-paper:var(--paper,#f3f0e8); --pf-ink:var(--ink,#121212); }
.pf-art .pf-cloud { transform-origin:1206px 164px; }
.pf-art .pf-trace { stroke-dasharray:1050; stroke-dashoffset:0; }
.pf-art[data-in] .pf-cloud { animation:pf-cloud-drift 14s ease-in-out infinite; }
.pf-art[data-in] .pf-trace { animation:pf-ring-trace 2.4s cubic-bezier(.2,.65,.3,1) .2s both; }
@keyframes pf-cloud-drift { 0%,100% { transform:translate(0,0); } 50% { transform:translate(12px,-8px); } }
@keyframes pf-ring-trace { from { stroke-dashoffset:1050; opacity:0; } to { stroke-dashoffset:0; opacity:1; } }
.reduce-motion .pf-art .pf-motion { animation:none!important; transform:none!important; }
@media(prefers-reduced-motion:reduce) { .pf-art .pf-motion { animation:none!important; transform:none!important; } }
`}</style>
      <defs>
        <linearGradient
          id='pf-wave'
          x1='0'
          y1='200'
          x2='2048'
          y2='700'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-blue)' stopOpacity='.2' />
          <stop offset='.48' stopColor='var(--pf-light)' stopOpacity='.06' />
          <stop offset='1' stopColor='var(--pf-blue)' stopOpacity='.16' />
        </linearGradient>
        <linearGradient
          id='pf-tower'
          x1='970'
          y1='98'
          x2='1134'
          y2='296'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-light)' stopOpacity='.82' />
          <stop offset='1' stopColor='var(--pf-blue)' stopOpacity='.62' />
        </linearGradient>
        <linearGradient
          id='pf-plane'
          x1='698'
          y1='214'
          x2='982'
          y2='314'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-pink)' stopOpacity='.97' />
          <stop offset='1' stopColor='var(--pf-pink)' stopOpacity='.8' />
        </linearGradient>
        <linearGradient
          id='pf-prism'
          x1='930'
          y1='386'
          x2='781'
          y2='603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-light)' stopOpacity='.96' />
          <stop offset='1' stopColor='var(--pf-blue)' stopOpacity='.86' />
        </linearGradient>
        <linearGradient
          id='pf-ring'
          x1='1010'
          y1='375'
          x2='1334'
          y2='483'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-pink)' stopOpacity='.98' />
          <stop offset='.46' stopColor='var(--pf-pink)' stopOpacity='.9' />
          <stop offset='1' stopColor='var(--pf-gold)' stopOpacity='.92' />
        </linearGradient>
        <linearGradient
          id='pf-ground'
          x1='0'
          y1='612'
          x2='2048'
          y2='769'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--pf-gold)' stopOpacity='.08' />
          <stop offset='.5' stopColor='var(--pf-paper)' stopOpacity='.04' />
          <stop offset='1' stopColor='var(--pf-pink)' stopOpacity='.1' />
        </linearGradient>
        <clipPath id='pf-tower-clip'>
          <path d='M970 98H1134V296H970Z' />
        </clipPath>
        <clipPath id='pf-cloud-clip'>
          <path d='M1028 214C1028 170 1063 136 1105 145C1120 114 1145 98 1179 98C1207 96 1235 109 1253 133C1289 116 1330 124 1356 153C1373 170 1382 191 1384 214Z' />
        </clipPath>
      </defs>
      <path
        d='M0 275C100 278 137 366 241 383C323 399 386 364 459 363C547 357 606 410 662 388C732 360 765 291 814 275C852 251 851 186 886 158C965 131 1029 184 1114 206C1197 231 1242 277 1302 331C1359 393 1396 406 1461 381C1547 348 1615 364 1700 381C1780 399 1830 381 1886 342C1947 295 1992 279 2048 275V612H0Z'
        fill='url(#pf-wave)'
      />
      <g stroke='var(--pf-blue)' strokeWidth='1.2'>
        <path
          d='M0 275C100 278 137 366 241 383C323 399 386 364 459 363C547 357 606 410 662 388C732 360 765 291 814 275C852 251 851 186 886 158C965 131 1029 184 1114 206C1197 231 1242 277 1302 331C1359 393 1396 406 1461 381C1547 348 1615 364 1700 381C1780 399 1830 381 1886 342C1947 295 1992 279 2048 275'
          strokeOpacity='.42'
        />
        <path
          d='M0 275C100 278 137 366 241 383C323 399 386 364 459 363C547 357 606 410 662 388C732 360 765 291 814 275C852 251 851 186 886 158C965 131 1029 184 1114 206C1197 231 1242 277 1302 331C1359 393 1396 406 1461 381C1547 348 1615 364 1700 381C1780 399 1830 381 1886 342C1947 295 1992 279 2048 275'
          transform='translate(0 14)'
          strokeOpacity='.2'
        />
        <path
          d='M0 275C100 278 137 366 241 383C323 399 386 364 459 363C547 357 606 410 662 388C732 360 765 291 814 275C852 251 851 186 886 158C965 131 1029 184 1114 206C1197 231 1242 277 1302 331C1359 393 1396 406 1461 381C1547 348 1615 364 1700 381C1780 399 1830 381 1886 342C1947 295 1992 279 2048 275'
          transform='translate(0 28)'
          strokeOpacity='.12'
        />
      </g>
      <path d='M0 612H2048V769H0Z' fill='url(#pf-ground)' />
      <g stroke='var(--pf-ink)' strokeWidth='1' strokeOpacity='.1'>
        <path d='M0 612H2048M0 650H2048M0 707H2048M1024 612V769' />
        <path d='M890 612L610 769M756 612L196 769M1158 612L1438 769M1292 612L1852 769' />
      </g>
      <ellipse
        cx='1024'
        cy='612'
        rx='344'
        ry='20'
        fill='var(--pf-ink)'
        fillOpacity='.2'
      />
      <ellipse
        cx='1024'
        cy='612'
        rx='344'
        ry='20'
        stroke='var(--pf-gold)'
        strokeOpacity='.28'
      />
      <g strokeWidth='1.5' strokeLinejoin='round'>
        <path
          d='M886 0H1053L1134 98H970Z'
          fill='var(--pf-gold)'
          fillOpacity='.72'
          stroke='var(--pf-ink)'
          strokeOpacity='.6'
        />
        <path
          d='M905 9H1048L1115 89H974Z'
          stroke='var(--pf-ink)'
          strokeOpacity='.3'
        />
        <path
          d='M886 0L970 98V296L886 199Z'
          fill='var(--pf-blue)'
          fillOpacity='.42'
          stroke='var(--pf-ink)'
          strokeOpacity='.55'
        />
        <path
          d='M970 98H1134V296H970Z'
          fill='url(#pf-tower)'
          stroke='var(--pf-ink)'
          strokeOpacity='.62'
        />
        <g
          clipPath='url(#pf-tower-clip)'
          stroke='var(--pf-ink)'
          strokeOpacity='.16'
        >
          <path d='M994 98V296' />
          <path d='M1008 98V296' />
          <path d='M1022 98V296' />
          <path d='M1036 98V296' />
          <path d='M1050 98V296' />
          <path d='M1064 98V296' />
          <path d='M1078 98V296' />
          <path d='M1092 98V296' />
          <path d='M1106 98V296' />
          <path d='M1120 98V296' />
        </g>
        <path
          d='M982 111H1122V284H982Z'
          stroke='var(--pf-ink)'
          strokeOpacity='.28'
        />
        <g className='pf-cloud pf-motion'>
          <path
            d='M1028 214C1028 170 1063 136 1105 145C1120 114 1145 98 1179 98C1207 96 1235 109 1253 133C1289 116 1330 124 1356 153C1373 170 1382 191 1384 214Z'
            fill='var(--pf-paper)'
            fillOpacity='.12'
            stroke='var(--pf-ink)'
            strokeOpacity='.58'
          />
          <g
            clipPath='url(#pf-cloud-clip)'
            stroke='var(--pf-blue)'
            strokeOpacity='.42'
          >
            <path
              d='M1028 214C1028 170 1063 136 1105 145C1120 114 1145 98 1179 98C1207 96 1235 109 1253 133C1289 116 1330 124 1356 153C1373 170 1382 191 1384 214Z'
              transform='translate(0 10)'
            />
            <path
              d='M1028 214C1028 170 1063 136 1105 145C1120 114 1145 98 1179 98C1207 96 1235 109 1253 133C1289 116 1330 124 1356 153C1373 170 1382 191 1384 214Z'
              transform='translate(0 20)'
            />
            <path d='M1028 204H1384M1028 194H1384' />
          </g>
        </g>
        <path
          d='M814 356L981 312L1011 470L930 386Z'
          fill='var(--pf-pink)'
          fillOpacity='.22'
          stroke='var(--pf-pink)'
          strokeOpacity='.46'
        />
        <path
          d='M698 214L869 172L982 312L814 357Z'
          fill='url(#pf-plane)'
          stroke='var(--pf-pink)'
        />
        <path
          d='M718 222L865 187L961 306L820 342Z'
          stroke='var(--pf-paper)'
          strokeOpacity='.48'
        />
        <path
          d='M742 232L859 204M752 244L869 216M762 256L879 228'
          stroke='var(--pf-paper)'
          strokeOpacity='.28'
        />
        <path
          d='M1047 298C991 296 950 326 944 369C940 408 968 443 1009 474C986 414 1000 352 1047 298Z'
          fill='var(--pf-blue)'
          fillOpacity='.5'
          stroke='var(--pf-blue)'
          strokeOpacity='.75'
        />
        <path
          d='M814 357L930 386L780 603Z'
          fill='url(#pf-prism)'
          stroke='var(--pf-ink)'
          strokeOpacity='.62'
        />
        <path
          d='M930 386L1000 483L780 603Z'
          fill='var(--pf-pink)'
          fillOpacity='.64'
          stroke='var(--pf-pink)'
          strokeOpacity='.68'
        />
        <path
          d='M780 603L1000 483L909 557Z'
          fill='var(--pf-gold)'
          fillOpacity='.68'
          stroke='var(--pf-ink)'
          strokeOpacity='.6'
        />
        <path
          d='M825 376L908 397L796 565Z'
          stroke='var(--pf-paper)'
          strokeOpacity='.32'
        />
        <path
          d='M928 405L976 478L809 577M926 425L953 475L837 552'
          stroke='var(--pf-paper)'
          strokeOpacity='.2'
        />
      </g>
      <g strokeLinejoin='round'>
        <path
          d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294ZM1121 354C1155 331 1196 349 1227 381C1258 412 1265 451 1240 477C1216 502 1175 488 1141 467C1105 445 1073 386 1121 354Z'
          transform='translate(-26 38)'
          fill='var(--pf-ink)'
          fillOpacity='.84'
          fillRule='evenodd'
          stroke='var(--pf-ink)'
          strokeOpacity='.7'
          strokeWidth='1.5'
        />
        <path
          d='M1170 345C1191 349 1211 362 1227 381C1258 412 1265 451 1240 477C1231 486 1218 491 1204 490L1138 432Z'
          fill='var(--pf-pink)'
          fillOpacity='.56'
        />
        <path
          d='M1104 439C1136 417 1182 440 1204 490C1181 488 1159 478 1141 467C1126 458 1113 448 1104 439Z'
          fill='var(--pf-blue)'
          fillOpacity='.58'
        />
        <path
          d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294ZM1121 354C1155 331 1196 349 1227 381C1258 412 1265 451 1240 477C1216 502 1175 488 1141 467C1105 445 1073 386 1121 354Z'
          fill='url(#pf-ring)'
          fillRule='evenodd'
          stroke='var(--pf-ink)'
          strokeOpacity='.62'
          strokeWidth='1.5'
        />
        <g stroke='var(--pf-paper)' strokeWidth='1' strokeOpacity='.22'>
          <path
            d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294Z'
            transform='translate(1172 425) scale(.94) translate(-1172 -425)'
          />
          <path
            d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294Z'
            transform='translate(1172 425) scale(.87) translate(-1172 -425)'
          />
          <path
            d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294Z'
            transform='translate(1172 425) scale(.80) translate(-1172 -425)'
          />
        </g>
        <path
          className='pf-trace pf-motion'
          d='M1063 294C1125 260 1208 287 1267 342C1327 398 1350 475 1314 527C1278 580 1207 582 1142 548C1071 513 1014 444 1010 384C1006 343 1022 313 1063 294Z'
          stroke='var(--pf-ink)'
          strokeWidth='1.6'
          strokeOpacity='.62'
        />
      </g>
    </svg>
  )
}
